import { render, staticRenderFns } from "./AiCareDemo.vue?vue&type=template&id=3da45844&scoped=true&"
import script from "./AiCareDemo.vue?vue&type=script&lang=ts&"
export * from "./AiCareDemo.vue?vue&type=script&lang=ts&"
import style0 from "./AiCareDemo.vue?vue&type=style&index=0&id=3da45844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da45844",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCombobox,VDialog,VIcon,VProgressCircular})
